import { useState, useMemo, useEffect } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import CreateCliente from '../components/Usuarios/CreateCliente';
import notifications from '../components/notifications';
import ReactCountryFlag from "react-country-flag";

const FlagLabel = ({ countryCode, text }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{ fontSize: "1.5em" }}
      aria-label={countryCode}
    />
    <span>{text}</span>
  </span>
);

function getObsAutoFillOptions() {
  return [
    "Processo individual completo.",
    "Processo em família.",
    "Cliente em contato pelo WhatsApp.",
    "Ainda não efetuou pagamento da assessoria.",
    "Já efetuou o pagamento da assessoria.",
    "Falta agora preencher o nosso formulário online e depois fazer a primeira vídeo chamada de análise.",
  ];
}

function Produzir() {
  const [notificationType, setNotificationType] = useState(0);

  const [servicesError, setServicesError] = useState(false);
  const [vendedorError, setVendedorError] = useState(false);
  const [produtorError, setProdutorError] = useState(false);
  const [clienteError, setClienteError] = useState(false);

  const [nome, setNome] = useState("");
  const [contato, setContato] = useState("");

  const [dsAdulto, setDsAdulto] = useState(0);
  const [dsKids, setDsKids] = useState(0);
  const [australiaForm, setAustraliaForm] = useState(0);
  const [i140Form, setI140Form] = useState(0);
  const [canadaForm, setCanadaForm] = useState(0);
  const [passport, setPassport] = useState(0);

  const [obsProd, setObsProd] = useState("");
  const [produtor, setProdutor] = useState("");
  const [statusProd, setStatusProd] = useState(0);
  const [vendedorProd, setVendedorProd] = useState("");
  const [formularioProd, setFormularioProd] = useState([]);
  const [analiseProd, setAnaliseProd] = useState("");
  const [clienteId, setClienteId] = useState("");

  const [colaboradoresSel, setColaboradoresSel] = useState([]);
  const [colabOptions, setColabOptions] = useState([]);

  const [comprovanteNome, setComprovanteNome] = useState("");
  const [comprovanteContato, setComprovanteContato] = useState("");
  const [comprovantePreenchendo, setComprovantePreenchendo] = useState(0);
  const [comprovanteObsProd, setComprovanteObsProd] = useState("");
  const [comprovanteAnalise, setComprovanteAnalise] = useState(0);
  const [dataCadastroComprovante, setDataCadastroComprovante] = useState("");
  const [uniqueClientLink, setUniqueClientLink] = useState("");

  const [clientesList, setClientesList] = useState([]);
  const [parceirosList, setParceirosList] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);

  const [estadoAnalise, setEstadoAnalise] = useState(false);
  const [comprovanteEnviadoProd, setComprovanteEnviadoProd] = useState(false);

  const [showAllClientes, setShowAllClientes] = useState(false);

  const totalForms =
    (Number(dsAdulto) || 0) +
    (Number(dsKids) || 0) +
    (Number(passport) || 0);

  const [obsSuggestions, setObsSuggestions] = useState(getObsAutoFillOptions());

  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  const handleAddObsSnippet = (snippet) => {
    setObsProd((prev) => {
      if (!prev || prev.trim() === "") return snippet;
      return `${prev.trim()}\n${snippet}`;
    });

    setObsSuggestions((prev) => prev.filter((item) => item !== snippet));
  };

  async function getClienteDetails(selectedClienteId) {
    if (!selectedClienteId) return;

    try {
      const response = await api.get(`/clienteAgiliza/${selectedClienteId}`);
      setNome(response.data?.Nome || "");
      setContato(response.data?.contato || "");
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }

  useEffect(() => {
    getClienteDetails(clienteId);
  }, [clienteId]);

  async function getUsers() {
    try {
      const [resCliente, resParceiro] = await Promise.all([
        api.get('/clientesAgiliza'),
        api.get('/clientesParceiros'),
      ]);

      setParceirosList(resParceiro.data || []);
      setClientesList(resCliente.data || []);
    } catch (error) {
      console.error('Erro ao carregar clientes/parceiros:', error);
      NotificationManager.error('Erro ao carregar clientes e parceiros.', 'Erro');
    }
  }

  const getVendedoresProdutores = async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');

      if (
        resVendedoresProdutores.data &&
        Array.isArray(resVendedoresProdutores.data.data)
      ) {
        const users = resVendedoresProdutores.data.data;

        setVendedoresList(users.filter((user) => user.is_vendedor === 1));
        setProdutoresList(users.filter((user) => user.is_produtor === 1));

        const uniq = [];
        const byCpf = new Set();

        for (const u of users) {
          const cpf = String(u.cpf || '').replace(/\D/g, '');
          if (!byCpf.has(cpf) && cpf) {
            byCpf.add(cpf);
            uniq.push({ ...u, cpf });
          }
        }

        setColabOptions(uniq);
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  };

  useEffect(() => {
    getVendedoresProdutores();
    getUsers();
  }, []);

  const validateFormProd = () => {
    let hasError = false;

    const totalServices =
      (Number(dsAdulto) || 0) +
      (Number(dsKids) || 0) +
      (Number(canadaForm) || 0) +
      (Number(australiaForm) || 0) +
      (Number(i140Form) || 0) +
      (Number(passport) || 0);

    if (totalServices === 0) {
      setServicesError(true);
      hasError = true;
    } else {
      setServicesError(false);
    }

    if (!String(vendedorProd || '').trim()) {
      setVendedorError(true);
      hasError = true;
    } else {
      setVendedorError(false);
    }

    if (!String(produtor || '').trim()) {
      setProdutorError(true);
      hasError = true;
    } else {
      setProdutorError(false);
    }

    if (clienteId === "" || clienteId === 0) {
      setClienteError(true);
      hasError = true;
      setNotificationType(20);
    } else {
      setClienteError(false);
    }

    if (hasError) {
      setNotificationType(3);
      return false;
    }

    return true;
  };
  const insertDataProd = async () => {
    if (!validateFormProd()) return;

    const formattedFormularios =
      formularioProd.length === 0 || formularioProd.every((form) => !String(form || '').trim())
        ? Array.from({ length: totalForms }, (_, i) => `FORM ${i + 1}`)
        : formularioProd;

    const dataCadastroAtual = new Date().toISOString().split('T')[0];

    const data = {
      dsAdulto,
      dsKids,
      canadaForm,
      i140Form,
      australiaForm,
      passport,
      preenchendo: false,
      obsProd,
      produtor,
      statusProd,
      vendedorProd,
      analise: estadoAnalise ? 1 : 0,
      dataCadastro: dataCadastroAtual,
      dataProduzindo: null,
      dataEntregue: null,
      analiseProd,
      formularioProd: formattedFormularios,
      ClienteId: clienteId,
      colaboradores: colaboradoresSel,
    };

    try {
      const res = await api.post('/cadastrarProd', data);

      if (res.data?.status === true) {
        setNotificationType(1);
        await getUsers();

        const origin = window.location.origin;
        let linkUnicoCliente = "";

        try {
          const tokenResponse = await api.post('/cliente/gerar-token', {
            clienteId: clienteId
          });

          if (tokenResponse.data?.status && tokenResponse.data?.token) {
            const token = tokenResponse.data.token;
            linkUnicoCliente = `${origin}/formulario/${token}`;
          } else {
            console.error("Erro ao gerar token");
          }
        } catch (error) {
          console.error("Erro ao gerar link seguro:", error);
        }

        setUniqueClientLink(linkUnicoCliente);
        setComprovanteEnviadoProd(true);
        setComprovanteNome(nome);
        setComprovanteContato(contato);
        setComprovanteObsProd(obsProd);
        setDataCadastroComprovante(dataCadastroAtual);
        setComprovanteAnalise(estadoAnalise ? 1 : 0);
        setComprovantePreenchendo(0);
        setColaboradoresSel([]);

        clearDataProd();
      } else {
        setNotificationType(2);
      }
    } catch (error) {
      console.error("Erro ao cadastrar produção:", error);
      setNotificationType(2);
    }
  };

  const clearDataProd = () => {
    setDsAdulto(0);
    setDsKids(0);
    setCanadaForm(0);
    setI140Form(0);
    setAustraliaForm(0);
    setPassport(0);
    setObsProd("");
    setProdutor("");
    setStatusProd(0);
    setVendedorProd("");
    setAnaliseProd("");
    setFormularioProd([]);
    setEstadoAnalise(false);
    setColaboradoresSel([]);
    setObsSuggestions(getObsAutoFillOptions());
  };

  const handleToggleShowAll = () => {
    setShowAllClientes((prevState) => !prevState);
  };

  const handleClienteSelecionado = (selectedClienteId) => {
    setClienteId(selectedClienteId);
    console.log('Cliente selecionado ID:', selectedClienteId);
  };


  async function handleClienteCriado(novoCliente) {
    setClientesList((prevList) => [...prevList, novoCliente]);
    handleClienteSelecionado(novoCliente.id);
  }

  const availableColabOptions = useMemo(() => {
    const vend = String(vendedorProd || '').replace(/\D/g, '');
    const prod = String(produtor || '').replace(/\D/g, '');
    return colabOptions.filter((u) => u.cpf !== vend && u.cpf !== prod);
  }, [colabOptions, vendedorProd, produtor]);

  useEffect(() => {
    const vend = String(vendedorProd || '').replace(/\D/g, '');
    const prod = String(produtor || '').replace(/\D/g, '');
    setColaboradoresSel((prev) => prev.filter((cpf) => cpf !== vend && cpf !== prod));
  }, [vendedorProd, produtor]);

  const toggleColaborador = (rawCpf) => {
    const cpf = String(rawCpf).replace(/\D/g, '');
    setColaboradoresSel((prev) =>
      prev.includes(cpf) ? prev.filter((c) => c !== cpf) : [...prev, cpf]
    );
  };

  const Counter = ({ label, value, setValue }) => {
    const qnt = Number(value) || 0;
    const ativo = qnt > 0;

    const inc = () => setValue(qnt + 1);
    const dec = () => setValue(Math.max(0, qnt - 1));

    if (!ativo) {
      return (
        <div
          className={styles.servicosAgil}
          onClick={() => setValue(1)}
          title="Adicionar 1"
        >
          {label}
        </div>
      );
    }

    return (
      <div className={styles.servicosAgilClic}>
        <p>{label}</p>
        <div className={styles.servicosAgilClicDiv}>
          <button type="button" className={styles.buttonQuadrado} onClick={dec}>
            -
          </button>
          <p style={{ fontSize: "1rem" }}>{qnt}</p>
          <button type="button" className={styles.buttonQuadrado} onClick={inc}>
            +
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const anyService =
      (Number(dsAdulto) || 0) +
      (Number(dsKids) || 0) +
      (Number(australiaForm) || 0) +
      (Number(i140Form) || 0) +
      (Number(canadaForm) || 0) +
      (Number(passport) || 0);

    if (anyService > 0 && servicesError) {
      setServicesError(false);
    }


  }, [dsAdulto, dsKids, passport, servicesError, canadaForm, i140Form, australiaForm, totalForms]);

  return (
    <div className={styles.app}>
      <NotificationContainer />

      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>CLIENTES</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <CreateCliente
          clientesList={clientesList}
          onClienteCriado={handleClienteCriado}
          handleToggleShowAll={handleToggleShowAll}
          showAllClientes={showAllClientes}
          parceirosList={parceirosList}
          onClienteSelecionado={handleClienteSelecionado}
          errorCliente={clienteError}
        />
      </div>

      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>PRODUÇÃO DS-160</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div
          className={styles.containerVendedorInput}
          style={{ paddingTop: "15px", display: "flex", flexDirection: "column", alignItems: "center" }}
        >
          <div className={styles.rowTwoCols}>
            <div className={styles.containerVendedor}>
              <select
                onChange={(e) => {
                  setVendedorProd(e.target.value);
                  setVendedorError(false);
                }}
                value={vendedorProd}
                className={`${styles.inputFilter} ${styles.fullWidth} ${vendedorError ? styles.errorBorder : ''}`}
              >
                <option value="">Vendedor</option>
                {vendedoresList.map((v) => (
                  <option
                    key={v.id}
                    value={v.cpf}
                    style={{ fontSize: '24px', fontWeight: 'bold' }}
                  >
                    {v.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.containerVendedor}>
              <select
                onChange={(e) => {
                  setProdutor(e.target.value);
                  setProdutorError(false);
                }}
                value={produtor}
                className={`${styles.inputFilter} ${styles.fullWidth} ${produtorError ? styles.errorBorder : ''}`}
              >
                <option value="">Produtor</option>
                {produtoresList.map((p) => (
                  <option
                    key={p.id}
                    value={p.cpf}
                    style={{ fontSize: '24px', fontWeight: 'bold' }}
                  >
                    {p.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className={styles.containerVendedor} style={{ paddingTop: 10 }}>
            <p className={styles.inputText}>ADCIONE COLABORADORES:</p>

            <div
              className={styles.colabGrid}
              style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
            >
              {availableColabOptions.map((u) => {
                const selected = colaboradoresSel.includes(u.cpf);

                return (
                  <button
                    key={u.cpf}
                    type="button"
                    onClick={() => toggleColaborador(u.cpf)}
                    aria-pressed={selected}
                    className={`${styles.colabButton} ${selected ? styles.colabButtonSelected : ''}`}
                    style={{
                      padding: '8px 8px',
                      borderRadius: 8,
                      border: '4px solid var(--corPrimaria)',
                      cursor: 'pointer',
                      background: selected ? 'var(--corPrimaria)' : 'transparent',
                      color: selected ? 'var(--onPrimary, #fff)' : 'inherit',
                      transition: 'background .15s ease, color .15s ease, border-color .15s ease',
                      fontWeight: 'bold',
                    }}
                    title={`${u.nome} - ${u.cpf}`}
                  >
                    {u.nome}
                  </button>
                );
              })}
            </div>
          </div>

          <div className={styles.containerVendedorInput}>
            <div className={styles.cityContainer} style={{ paddingTop: "10px" }}>
              <label className={styles.containerCb}>
                <input
                  id="checkBox8"
                  type="checkbox"
                  checked={estadoAnalise}
                  onChange={(e) => setEstadoAnalise(e.target.checked)}
                  name="translateRadio"
                />
                <span className={styles.checkmark}></span>
              </label>
              <p className={styles.cidadeText}>
                Fez análise Perfil (Anotações sobre o perfil)
              </p>
            </div>
          </div>

          <p className={styles.inputText} style={{ margin: 10 }}>
            --------------- FORMULARIOS ---------------
          </p>

          <div className={`${styles.cadastroItems06} ${servicesError ? styles.errorBorder : ''}`}>
            <Counter
              label={<FlagLabel countryCode="US" text="DS-160 (Adulto)" />}
              value={dsAdulto}
              setValue={setDsAdulto}
            />
            <Counter
              label={<FlagLabel countryCode="US" text="DS-160 (Criança)" />}
              value={dsKids}
              setValue={setDsKids}
            />
            <Counter
              label={<FlagLabel countryCode="CA" text="VISTO CANADÁ" />}
              value={canadaForm}
              setValue={setCanadaForm}
            />
            <Counter
              label={<FlagLabel countryCode="BR" text="PASSAPORTE" />}
              value={passport}
              setValue={setPassport}
            />
          </div>

          <div className={styles.divisor}></div>

          <p className={styles.inputText} style={{ margin: 10 }}>
            --------------- OBSERVAÇÕES ---------------
          </p>

          <div className={styles.cadastroItems04}>
            <div className={styles.itemContainer}>
              <textarea
                onChange={(e) => setObsProd(e.target.value)}
                value={obsProd}
                className={styles.textArea}
                placeholder="Deixe uma observação sobre o cliente"
              ></textarea>
            </div>
          </div>

          {obsSuggestions.length > 0 && (
            <>
              <p className={styles.inputText} style={{ marginTop: 5, marginBottom: 5 }}>
                Sugestões rápidas:
              </p>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginBottom: "10px",
                }}
              >
                {obsSuggestions.map((snippet, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => handleAddObsSnippet(snippet)}
                    className={styles.colabButton}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "12px",
                      border: "1px solid var(--corPrimaria)",
                      background: "white",
                      cursor: "pointer",
                      fontSize: "0.8rem",
                      maxWidth: "180px",
                      whiteSpace: "normal",
                      textAlign: "left",
                    }}
                  >
                    {snippet}
                  </button>
                ))}
              </div>
            </>
          )}

          {estadoAnalise ? (
            <div className={styles.cadastroItems04}>
              <div className={styles.itemContainer}>
                <p className={styles.inputText}>Analise de Perfil:</p>
                <textarea
                  onChange={(e) => setAnaliseProd(e.target.value)}
                  value={analiseProd}
                  className={styles.textArea}
                  placeholder="Digite a Analise de perfil do cliente"
                ></textarea>
              </div>
            </div>
          ) : null}



          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={() => {
                setStatusProd(0);
                insertDataProd();
              }}
              className={styles.cadastroCliente}
            >
              PRODUZIR
            </button>
          </div>
        </div>

        {comprovanteEnviadoProd ? (
          <div
            className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
            onClick={() => {
              const r = document.createRange();
              const target = document.getElementById('copiar3');

              if (!target) return;

              r.selectNode(target);
              window.getSelection().removeAllRanges();
              window.getSelection().addRange(r);

              try {
                document.execCommand('copy');
                window.getSelection().removeAllRanges();
                setNotificationType(19);
              } catch (err) {
                console.log('Unable to copy!');
              }
            }}
          >
            <div className={styles.copiarTop}>
              COMPROVANTE (clica para copiar)
            </div>

            <div id="copiar3" className={styles.copiarText}>
              <p>Nome: {comprovanteNome}</p>
              <p>Contato: {comprovanteContato}</p>
              <br />
              <p>Obs: {comprovanteObsProd}</p>

              {comprovanteAnalise === 1 && (
                <div>
                  <p>Fez análise de Perfil.</p>
                  <br />
                </div>
              )}

              {comprovantePreenchendo === 1 && (
                <div>
                  <p>Já preencheu o Formulário.</p>
                </div>
              )}

              <div>
                <p>Link para preenchimento dos formulários:</p>
                <a href={uniqueClientLink} target="_blank" rel="noopener noreferrer">
                  {uniqueClientLink}
                </a>
              </div>

              <br />
              <p>Data de Cadastro: {dataCadastroComprovante}</p>
            </div>
          </div>
        ) : null}

        <div className={styles.divisor}></div>
      </div>
    </div>
  );
}

export default Produzir;